
// src/components/Footer.js
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Footer() {
  return (
    <Box component="footer" sx={{ p: 2, textAlign: 'center', bgcolor: '#f5f5f5' }}>
      <Typography variant="caption">© 2025 | All Rights Reserved JSSISH</Typography>
    </Box>
  );
}
